
import { Agent, Node, AgentState, AgentType, SimulationConfig } from '../types';
import { MAX_PATIENCE_TICKS } from '../constants';

const generateId = () => Math.random().toString(36).substr(2, 9);

export const createAgent = (
  type: AgentType, 
  startNode: Node, 
  simTick: number, 
  patientPatience: number, 
  simConfig: SimulationConfig,
  patientToAccompany?: Agent
): Agent => {
  let acuity = 3;
  if (type === AgentType.PATIENT_TRAUMA || type === AgentType.PATIENT_STROKE) acuity = 1;
  else if (type === AgentType.PATIENT_EMS || type === AgentType.PATIENT_INFECTIOUS) acuity = 2;

  const patience = (patientPatience || MAX_PATIENCE_TICKS) * (0.8 + Math.random() * 0.4);

  return {
    id: generateId(),
    type,
    state: AgentState.IDLE,
    x: startNode.x,
    y: startNode.y,
    currentNodeId: startNode.id,
    targetNodeId: null,
    path: [],
    progress: 0,
    health: 100,
    infected: type === AgentType.PATIENT_INFECTIOUS,
    infectionRisk: 0,
    totalWaitTime: 0,
    totalDistancePixels: 0,
    totalActiveTime: 0,
    tickCreated: simTick,
    tickOnArrival: simTick,
    tickFirstSeen: null,
    tickLabOrdered: null,
    tickLabResult: null,
    acuity,
    patience,
    maxPatience: patience,
    assignedStaffId: null,
    assignedPatientId: null,
    companionOf: patientToAccompany?.id || null,
    needsLab: type !== AgentType.COMPANION && Math.random() > 0.5,
    labDone: false,
    needsImaging: type !== AgentType.COMPANION && Math.random() < simConfig.imagingRate / 100,
    imagingDone: false,
    needsPharmacy: type !== AgentType.COMPANION && Math.random() > 0.5,
    awaitingResults: false
  };
};
